import React from "react";
import Footer from "../../../components/Landing/Footer/Footer";
import Hero from "../../../components/Landing/HeroForm/Hero";
import UpButton from '../../../components/UpButton';
//------------------------------------------------
import { Helmet } from "react-helmet";
//==
import  { useContext , useEffect } from 'react';
import { LanguageContext } from '../../../context/LanguageContext';
//==
const LandingThanksPage = ({scroll , lang , page}) => {
  //==
    const {  toggleLanguage } = useContext(LanguageContext);
    useEffect(() => {
        toggleLanguage(lang)
    }, );
    const content = {
        en: {
            message :'Thanks , We Will Contact You As Soon As Possible',
        },
        ar: {
            message :'شكرًا لك، سنتواصل معك في أقرب وقت ممكن',
        }
    };
    return (
        <div>
        <Helmet>
            <title>Millensys - Landing - Form</title>
            <script type="text/javascript">
            {`            
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "qeh6bpz9s1");
            `}
            </script>
        </Helmet>
        <UpButton scroll={scroll} />
        <div>
            <Hero/>
            <div className="d-flex h-full p-5 m-auto w-75 justify-content-center align-items-center">
                <span className={`text-success mt-5 mb-5 fst-italic fs-4`}>{content[lang].message}</span>
            </div>
            <Footer/>
        </div>
        </div>
    );
};

export default LandingThanksPage;